export interface ConsentState {
  enpalMarketingConsent: boolean;
  thirdPartyMarketing: boolean;
  thirdPartyProfiling: boolean;
}

export const DEFAULT_CONSENT_STATE: ConsentState = {
  enpalMarketingConsent: false,
  thirdPartyMarketing: false,
  thirdPartyProfiling: false,
};
